import { OrderDetailIdDetailRequest } from './order';
import { UserInfo } from '../../redux/features/login-slice/index';

export type HttpErrorResponseObject = {
  response: {
    data: string;
    status: number;
    statusText: string;
  };
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export type HttpResponseObject = {
  status: number;
  message: string;
};

/**
 * ApiResponse<T> - Generic API response wrapper
 * Following backend error handling standards (ERROR-HANDLING-STANDARDS.md)
 *
 * @template T - The type of data in successful response
 *
 * Success response structure:
 * {
 *   status: 200,
 *   success: true,
 *   errorCode: null,
 *   message: "Success message",
 *   data: T,
 *   timestamp: "2025-10-03T17:05:13"
 * }
 *
 * Error response structure:
 * {
 *   status: 401,
 *   success: false,
 *   errorCode: 10401,
 *   message: "Invalid username/email or password",
 *   data: null,
 *   timestamp: "2025-10-03T17:05:13"
 * }
 */
export type ApiResponse<T = any> = {
  status: number;
  success: boolean;
  errorCode: number | null;
  message: string;
  data: T | null;
  timestamp: string;
};

export type CategoryItems = {
  id: number;
  name: string;
  checked: boolean;
  childs: CategoryChilds[];
};

export interface ICustomerBooking {
  id?: number;
  infoId?: number;
  address?: string;
  dateOfBirthday?: string;
  email?: string;
  gender?: string;
  fullName?: string;
  phone?: string;
  callingCodes?: string;
  nameCountry?: string;
  job?: {
    id: number;
    name: string;
  };
}

export type CategoryChilds = {
  id: number;
  name: string;
  mean?: string;
  note?: string;
  parentId?: number;
  level?: number;
  noteTest?: string;
  checked: boolean;
  sequenceId: number;
};

export type OrderDetailsRequest = {
  id: number;
  name: string;
  note?: string;
  noteTest?: string;
  parentId?: number;
  level?: number;
};

export type OrderItemsRequest = {
  id: number;
  childs: OrderDetailsRequest[];
};

export interface ItemObject {
  id: number;
  name: string;
  details: OrderDetailIdDetailRequest[];
  checked?: boolean;
}

export type OrderRequestObject = {
  id?: number;
  doctorId?: number;
  hospitalId?: number;
  departmentId?: number;
  orderAdress?: string;
  orderPhone?: string;
  orderType?: string;
  infomation?: {
    id?: number;
    fullName: string;
    phone: string;
    callingCodes: string;
    nameCountry: string;
    dateOfBirth?: string;
    gender: string;
    email?: string;
    address: string;
  };
  categoryId?: number;
  render?: boolean;
  contrast?: boolean;
  testDayTime: string;
  categoryTypeId?: number;
  items?: OrderItemsRequest[];
  note?: string;
  atHome?: boolean;
  timeCustome?: boolean;
  diagnostic?: string;
  reasonForExamination?: string;
  clinicAddress?: string;
  method_id: number;
  linkOnline: string;
};

export type OrderVaccineRequestObject = {
  id?: number;
  doctorId?: number;
  hospitalId?: number;
  departmentId?: number;
  orderAdress?: string;
  orderPhone?: string;
  orderType?: string;
  infomation?: {
    id?: number;
    fullName: string;
    phone: string;
    callingCodes: string;
    nameCountry: string;
    dateOfBirth?: string;
    gender: string;
    email?: string;
    address: string;
  };
  categoryId?: number;
  render?: boolean;
  contrast?: boolean;
  testDayTime: string;
  categoryTypeId?: number;
  items?: OrderItemsRequest[];
  note?: string;
  atHome?: boolean;
  timeCustome?: boolean;
  diagnostic?: string;
  reasonForExamination?: string;
  clinicAddress?: string;
  method_id: number;
  vaccineId: number;
  scheduleId?: number;
  vaccineDoseId: number;
  adverseEvent?: string;
  vaccineBrand?: string;
};

export const defaultOrderVaccineRequestObject: OrderVaccineRequestObject = {
  id: 0,
  doctorId: 0,
  hospitalId: 0,
  departmentId: 0,
  orderAdress: '',
  orderPhone: '',
  orderType: '',
  infomation: {
    id: 0,
    fullName: '',
    phone: '',
    callingCodes: '',
    nameCountry: '',
    dateOfBirth: '',
    gender: '',
    email: '',
    address: '',
  },
  categoryId: 13,
  render: false,
  contrast: false,
  testDayTime: '',
  categoryTypeId: 0,
  items: [],
  note: '',
  atHome: false,
  timeCustome: false,
  diagnostic: '',
  reasonForExamination: '',
  clinicAddress: '',
  method_id: 2,
  vaccineId: 0,
  scheduleId: 0,
  vaccineDoseId: 0,
};

export type OrderFormRequestObject = {
  orderAdress: string;
  orderPhone: string;
  orderType: string;
  infomation?: {
    id: number;
    fullName: string;
    phone: string;
    callingCodes: string;
    nameCountry: string;
    dateOfBirth: string;
    gender: string;
    email: string;
    address: string;
    infoId: number;
  };
  checkTestItems?: boolean;
  testDay: string;
  testTime: string;
  categoryTypeId: number;
  packageTestItems: CategoryItems[];
  requestTestItems: CategoryItems[];
  note?: string;
  atHome: boolean;
  timeCustome?: boolean;
  place?: string;
  previousPhoneNumber?: string;
  clinicAddress: string;
  method_id: number;
  linkOnline: string;
};

export type OrderRequest = {
  listOrder: OrderRequestObject[];
};

export type OrderVaccineRequest = {
  listOrder: OrderVaccineRequestObject[];
};

//online
export type OrderRequestOnline = {
  listOrder: OrderRequestObjectOnline[];
};
export type OrderRequestObjectOnline = {
  id?: number;
  doctorId?: number;
  hospitalId?: number;
  departmentId?: number;
  orderAdress?: string;
  orderPhone?: string;
  orderType?: string;
  infomation?: {
    id?: number;
    fullName: string;
    phone: string;
    callingCodes: string;
    nameCountry: string;
    dateOfBirth?: string;
    gender: string;
    email?: string;
    address: string;
  };
  categoryId?: number;
  render?: boolean;
  contrast?: boolean;
  testDayTime: string;
  categoryTypeId?: number;
  items?: OrderItemsRequest[];
  note?: string;
  atHome?: boolean;
  timeCustome?: boolean;
  diagnostic?: string;
  reasonForExamination?: string;
  clinicAddress?: string;
  method_id: number;
  linkOnline: string;
};

export type OrderForm = {
  listOrder: OrderFormRequestObject[];
};

export type AsyncReturnType<T extends (...args: any) => Promise<any> | null, U = unknown> = T extends (
  ...args: any
) => Promise<infer R>
  ? U extends R
    ? U
    : R
  : any;

export type IOption = {
  value: number;
  label: string;
};
